/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Usettings_Mute_DescriptionInputs */



/**
* | output |
* | --- |
* | "Hides the launcher, hints, and nudges. A small dot stays in the corner to bring Uno back." |
*
* @param {Uno_Usettings_Mute_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_usettings_mute_description = /** @type {((inputs?: Uno_Usettings_Mute_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Usettings_Mute_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Blendet den Starter, Hinweise und Anstöße aus. Ein kleiner Punkt bleibt in der Ecke, um Uno zurückzuholen.")
	return /** @type {LocalizedString} */ ("Hides the launcher, hints, and nudges. A small dot stays in the corner to bring Uno back.")
});